import { createSlice } from "@reduxjs/toolkit";
import { SecondaryNumberState } from "./secondary.types";
import {
    listSecondaryNumbersThunk,
    verifySecondaryOtpThunk,
    addSecondaryNumberThunk,
} from "./secondaryThunk";

const initialState: SecondaryNumberState = {
    loading: false,
    numbers: [],
    verified: false,
};

const secondarySlice = createSlice({
    name: "secondaryNumber",
    initialState,
    reducers: {
        resetSecondary: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(listSecondaryNumbersThunk.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(listSecondaryNumbersThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.numbers = action.payload;
            })
            .addCase(listSecondaryNumbersThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(addSecondaryNumberThunk.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(addSecondaryNumberThunk.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(addSecondaryNumberThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(verifySecondaryOtpThunk.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(verifySecondaryOtpThunk.fulfilled, (state) => {
                state.loading = false;
                state.verified = true;
            })
            .addCase(verifySecondaryOtpThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { resetSecondary } = secondarySlice.actions;
export default secondarySlice.reducer;
